<template>
  <OmtLayoutHeaderFooter
    :footer="false"
    :header="{ titleLabel: 'Cadastro de biometria' }"
  >
    <OmtLayoutContainer>
      <OmtRow>
        <BiometryAuthHeader />
      </OmtRow>

      <OmtRow mb="24px">
        <BiometryAuthCard />
      </OmtRow>

      <OmtRow>
        <BiometryCameraButton
          :disabled="alreadyRegistered"
          :confirmUser="true"
          :nameUser="nomeIdentificacao"
          buttonLabel="Começar"
          @success="handleBiometryCameraSuccess"
          @error="handleBiometryCameraError"
          @resourceError="handleResourceError"
          @startLoading="$root.$emit('show-loading')"
          @endLoading="$root.$emit('hide-loading')"
        />
      </OmtRow>
    </OmtLayoutContainer>
    <FeedbackModal
      v-if="modalInfos"
      :protocol="modalInfos.protocol"
      :title="modalInfos.title"
      :cardTitle="modalInfos.cardTitle"
      :cardDescription="modalInfos.cardDescription"
      :cardIcon="modalInfos.cardIcon"
      :modalIconBind="modalInfos.modalIconBind"
      :buttonLabel="modalInfos.buttonLabel"
      :secondButtonLabel="modalInfos.secondButtonLabel"
      @buttonClick="modalInfos.buttonClick"
      @close="modalInfos.close"
      @secondButtonClick="modalInfos.secondButtonClick"
    />
    <LoadingModal
      v-if="process"
      :title="process.title"
      :description="process.description"
      :loading="true"
    />
  </OmtLayoutHeaderFooter>
</template>

<script>
import LoadingModal from "@/components/Organisms/LoadingModal";
import BiometryCameraButton from "@/components/Organisms/Biometry/BiometryCameraButton";
import BiometryAuthHeader from "@/components/Organisms/Biometry/BiometryAuthHeader.vue";
import FeedbackModal from "@/components/Molecules/FeedbackModal";
import BiometryAuthCard from "@/components/Organisms/Biometry/BiometryAuthCard";
import { mapActions, mapState } from "vuex";
import biometryRegisterProcess from "@/mixins/biometryRegisterProcess";

export default {
  components: {
    LoadingModal,
    BiometryCameraButton,
    FeedbackModal,
    BiometryAuthCard,
    BiometryAuthHeader
  },
  mixins: [biometryRegisterProcess],
  data() {
    return {
      timer: null,
      modalToShow: "",
      process: null,
      alreadyRegistered: false,
      alreadyRegisteredProtocol: null,
      justRegisteredProtocol: null
    };
  },
  computed: {
    ...mapState("firstAccess", ["autenticado", "cadastrarEmail", "hash", "nomeIdentificacao"]),
    modals() {
      return {
        OnErrorModal: {
          title: "Não foi possível continuar",
          cardTitle: "Não foi possível detectar a câmera para captura",
          cardDescription:
            "Acesse os ajustes do seu smartphone e permita que o nosso app acesse sua câmera, ou realize a biometria em outro dispositivo.",
          cardIcon: "circle-exclamation",
          modalIconBind: {
            name: "circle-xmark",
            color: "var(--colors-light-primary-navy-blue)"
          },
          buttonLabel: "Entendi",
          buttonClick: this.handleCloseModalAndLeave,
          close: this.handleCloseModalAndLeave
        },
        SucessfullyRegistereBiometryModal: {
          title: "Biometria cadastrada com sucesso!",
          cardTitle: "Agora sua biometria está registrada no app",
          cardDescription: "Seu acesso, informações e transações já estão protegidos com o reconhecimento facial.",
          cardIcon: "face-viewfinder",
          modalIconBind: {
            name: "check-circle",
            color: "var(--colors-light-support-success)"
          },
          buttonLabel: "Concluir",
          buttonClick: this.handleCloseModalOnSucessfully,
          close: this.handleCloseModalOnSucessfully
        }
      };
    },
    modalInfos() {
      if (!this.modalToShow) return null;
      const result = this.modals[this.modalToShow];
      if (result) {
        result.secondButtonClick = this.handleCloseModalAndLeave;
        if (this.modalToShow !== "Ops") {
          result.protocol = this.alreadyRegisteredProtocol;
        }
      }
      return result;
    }
  },
  mounted() {
    if (!this.hash) {
      this.$router.replace({
        name: "first-access.terms"
      });
    }
  },
  methods: {
    ...mapActions("firstAccess", ["saveFace", "fetchFaceStatus", "registerError"]),
    finishLoadSituation(modalToShow) {
      this.quitLoadSituationProcess();
      if (modalToShow) {
        this.modalToShow = modalToShow;
        return;
      }
      this.handleCloseModalAndLeave();
    },
    handleFaceStatus(data) {
      const { Gerado, Aceito, Protocolo } = data;
      if (Gerado && !Aceito && this.process.step < 15) return;
      this.alreadyRegistered = Gerado;
      this.alreadyRegisteredProtocol = Protocolo;

      if (!Gerado) return this.finishLoadSituation();
      if (Aceito) return this.finishLoadSituation("SucessfullyRegistereBiometryModal");
      this.finishLoadSituation();
    },
    async handleError(error) {
      await this.$root.$emit("hide-loading");
      globalThis.window.$log.error("biometry page", error);
      this.handleCloseModalAndLeave();
    },
    async handleResourceError(error) {
      const response = await this.registerError({ cod: "init", dsc: JSON.stringify(error) });
      this.justRegisteredProtocol = response.Protocolo;
      this.modalToShow = "OnErrorModal";
    },
    handleBiometryCameraError(error) {
      globalThis.window.$log.error("biometry camera", error);
      this.registerError({ cod: "camera", dsc: JSON.stringify(error) });
    },
    handleCloseModalAndLeave() {
      this.$router.push({ name: this.cadastrarEmail ? "first-access.mailform" : "first-access.mailcheck" });
    },
    handleCloseModalOnSucessfully() {
      this.$router.push({ name: this.cadastrarEmail ? "first-access.mailform" : "first-access.password" });
    }
  }
};
</script>
